function roundUp(num: number, decimalPlaces: number) {
  const factor = 10 ** decimalPlaces;
  return Math.round(num * factor) / factor;
}

export function formatNumber(num: number, decimalPlaces: number = 2) {
  return roundUp(num, decimalPlaces).toFixed(decimalPlaces).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
